import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana16Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  } 

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
    <rect width="1221" height="921" fill="url(#pattern0_1467_37584)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M737.63 375.067L672.93 356.581L652.595 367.673L684.021 432.373L743.176 402.796C747.613 389.486 741.327 378.764 737.63 375.067Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M562.011 330.699L672.926 356.579L580.497 402.794L549.071 336.245L562.011 330.699Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M497.31 360.278L549.071 336.246L580.497 402.795L526.887 428.676L497.31 360.278Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M628.562 460.101L684.02 432.372L652.594 367.672L597.136 395.401L628.562 460.101Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M573.107 485.98L628.564 460.1L597.138 393.551L543.529 421.28L573.107 485.98Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M517.644 511.86L573.102 485.98L543.524 421.279L488.066 447.16L517.644 511.86Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M443.702 384.306L497.311 360.274L526.889 428.672L473.28 454.552L443.702 384.306Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M464.038 537.742L517.647 511.862L488.07 447.161L432.612 473.041L464.038 537.742Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M406.736 563.621L464.042 537.741L432.616 473.04L377.158 497.072L406.736 563.621Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M391.94 408.339L443.7 384.308L473.278 454.554L419.669 478.586L391.94 408.339Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M338.333 432.371L391.942 408.339L419.671 478.585L366.062 502.617L338.333 432.371Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M351.275 589.503L406.732 563.622L377.155 497.073L321.697 522.953L351.275 589.503Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M284.721 456.404L338.33 432.372L366.059 502.618L314.299 526.65L284.721 456.404Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M255.149 469.341L284.727 456.401L314.304 526.648L236.664 558.074L255.149 469.341Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M218.723 620.854L236.645 558.079L268.068 545.139L295.797 613.536L235.353 638.425C233.799 639.065 232.049 639.163 230.529 638.447C223.96 635.352 219.109 629.257 218.264 624.772C218.018 623.462 218.357 622.136 218.723 620.854Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M351.272 589.501L295.815 613.533L268.086 545.135L321.695 522.952L351.272 589.501Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1467_37584" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1467_37584" transform="matrix(0.00253565 0 0 0.00336159 -5.35799 -1.30362)"/>
    </pattern>
    <image id="image0_1467_37584"  width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};